// Шим над общим трекером: подставляет id игры. Поведение — в shared/analytics.
import { createTracker } from '../../../shared/analytics'

export const track = createTracker('water-sort')
